import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import useCrud from 'hooks/useCrud';
import { useEffect, useRef } from 'react';
import { scenario } from 'services/api/storeGroup';

export interface ScenarioTitleProps {
  storeGroupId: string | number;
  scenarioId: string | number;
  fallback?: string;
}

function ScenarioTitle(props: ScenarioTitleProps) {
  const { storeGroupId, scenarioId, fallback = ' ' } = props;

  const { loading, item, fetch } = useCrud({
    read: scenario,
  });

  const lang = useSystemLanguageValue();

  const refsCurrent = { fetch };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    refs.current.fetch({ storeGroupId, scenarioId, lang }).catch(() => {});
  }, [storeGroupId, scenarioId, lang]);

  if (loading) {
    return <></>;
  }

  if (item) {
    return <>{item.data.label}</>;
  }

  return <>{fallback}</>;
}

export default ScenarioTitle;
